/**
 * MultiDayEventBadge — Iter-408.
 *
 * Shows "Day 2 of 3" (or the compact "Day 2/3") for any shift that
 * carries `day_index` + `days_in_group`. Renders nothing when the
 * shift is a single-day event.
 */
import React from 'react';
import { CalendarRange } from 'lucide-react';

const MultiDayEventBadge = ({ dayIndex, daysInGroup, compact = false, className = '' }) => {
  if (!dayIndex || !daysInGroup || daysInGroup <= 1) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-cyan-300 bg-cyan-50 text-cyan-800 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 ${className}`}
      title={`Part of a ${daysInGroup}-day event`}
      data-testid={`multi-day-badge-${dayIndex}-of-${daysInGroup}`}
    >
      <CalendarRange className="w-3 h-3" />
      {compact ? `Day ${dayIndex}/${daysInGroup}` : `Day ${dayIndex} of ${daysInGroup}`}
    </span>
  );
};

export default MultiDayEventBadge;
